import { useEffect } from 'react';
import { prop, pick } from 'ramda';
import { get } from '@core/js/utils/fetch.util';
import { useDispatch } from 'react-redux';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';

import * as helpers from '@core/js/components/system/App/hooks/useGetOldGamesFeeds/helpers';
import * as actions from '@core/js/components/system/App/store/actions';
import { useGetCMSResourceURL } from '@core/js/hooks/useGetCMSResourceURL';

export const useGetOldGamesFeeds = () => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const { requestStamp, isOldGamesFeedsLoaded } = useAppSelector(pick(['requestStamp', 'isOldGamesFeedsLoaded']));

    useEffect(() => {
        if (!lang || isOldGamesFeedsLoaded) {
            return;
        }
        const requestURL = getCMSResourceURL(`/initialResources/games/${lang}`, { t: requestStamp });

        get(requestURL)
            .then(({ gamesFeeds, gamesTilesLayouts }) => {
                const oldGamesFeeds = helpers.parseGameFeeds(gamesFeeds);

                dispatch(actions.updateOldGamesFeeds({ oldGamesFeeds, gamesTilesLayouts }));
            });
    }, [dispatch, lang, requestStamp, getCMSResourceURL, isOldGamesFeedsLoaded]);
};
